import { ReactNode } from 'react';

import {
  Box,
  Stack,
  Typography
} from '@mui/material';



export type BaseFormLayoutProps = {
  title?: string;
  subTitle?: string;
  children: ReactNode | ReactNode[];
  stackedButton?: boolean;
  nextButton?: ReactNode;
  handleSubmit?: () => void;
  cancelButton?: ReactNode;
};

export const FC = (props: BaseFormLayoutProps) => {

  return (
    <Box
      component='form'
      onSubmit={(e) => {
        e.preventDefault();
        props.handleSubmit && props.handleSubmit();
      }}
    >
      <Stack
        direction='column'
        justifyContent='center'
        paddingBottom='2rem'
      >{
          props.title && (

            <Typography
              variant='loginFormTitle'
            >
              {props.title}
            </Typography>
          )
        }
        {
          props.subTitle && (
            <Typography
              variant='loginSectionSubTitle'
            >
              {props.subTitle}
            </Typography>
          )
        }
      </Stack>
      <Stack
        direction='column'
        display='flex'
        alignItems='center'
        rowGap='.75rem'
        paddingBottom='2rem'
      >
        {props.children}
      </Stack>
      <Stack
        direction='column'
        rowGap='.5rem'
      >
        {
          props.nextButton
          && (
            props.nextButton
          )
        }
        {props.cancelButton && (props.cancelButton)}
      </Stack>
    </Box>
  );
};
